import { env } from '../../common/util'

export const PLAN_IDS = {
  professional: { prod: '4hogzjs8p3zwu87y', staging: '', dev: 'ex1c48e86bqiqdjr' },
  ultimate: { prod: '24mu0d85fzuhqi5x', staging: '', dev: 'dmbv3q0nq9pf8dyd' },
}

export const getProfessionalPlanId = () => PLAN_IDS.professional[env]
export const getUltimatePlanId = () => PLAN_IDS.ultimate[env]

export const DOWNGRADE_FEATURES = {
  fromProfessional: [
    'Team Collaboration – meeting and contact sharing, Admin Assistant workflows, and team-based templates',
    'Zocks Forms – ability to complete data sheets from meetings and integrated data sources',
    'Zocks Insights – access to the Analytics Hub',
    'Meeting Scoring & Advisor Coaching',
    'Custom Data Retention Policies',
    'Transcript & Meeting Results Archiving',
  ],
  fromUltimate: [
    'Document Intelligence – automatically extract client documents, fill out PDF documents',
    'Email Processing – create tasks, contact updates and auto-draft smart replies',
    'Prospecting - create new contacts from intake documents',
    'Client Signals based automation - life and business event driven actions',
  ],
  generic: ['Access to advanced features included in your current plan', 'Premium functionality and capabilities'],
}
